// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label_content {
  float: left;
  position: relative;
  top: 18%;
}

.controls_feild {
  width: 70%;
  float: left;
  margin-left: 4%;
  height: 35px;
}

.controls_feild_lookvalue {
  width: 65%;
  float: left;
  margin-left: 4%;
  height: 35px;
  margin-top: -2px !important;
}

.icons {
  font-size: 16px;
  width: 16px;
  height: 16px;
  position: relative;
  top: 0px;
}

.interfaceMappingUpload {
  width: 3% !important;
  left: unset;
  opacity: 0 !important;
  position: absolute !important;
  top: 1% !important;
  overflow: hidden !important;
  right: 12% !important;
}

::ng-deep.messageFormat_select {
  padding-left: 10px !important;
}

::ng-deep.messageFormat_select .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 13px;
}

::ng-deep.messageFormat_select .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.messageFormat_select .mat-form-field-label-wrapper {
  top: -1px !important;
}

::ng-deep.messageFormat_select .mat-select-trigger {
  min-width: 10vw;
}

.searchtext {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  border-radius: 5px !important;
}

::ng-deep.messageFormat_select .mat-mdc-text-field-wrapper {
  height: 35px !important;
}
::ng-deep.messageFormat_select .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}
::ng-deep.messageFormat_select .mat-mdc-select {
  position: relative !important;
  bottom: 11px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/messageattributes/messageattributes.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;AACF;;AAEA;EACE,UAAA;EACE,WAAA;EACA,eAAA;EACA,YAAA;AACJ;;AAEA;EACE,UAAA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,2BAAA;AACJ;;AAEA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;AACF;;AACA;EAEE,oBAAA;EACA,WAAA;EACA,qBAAA;EACA,6BAAA;EACA,kBAAA;EACA,2BAAA;EACA,qBAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AACA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;AAEF;;AAAA;EACE,WAAA;EACA,UAAA;AAGF;;AADA;EACE,oBAAA;AAIF;;AAFA;EACE,eAAA;AAKF;;AAFA;EACE,oDAAA;EACA,6BAAA;AAKF;;AADE;EACE,uBAAA;AAIJ;AAFE;EACE,wBAAA;AAIJ;AAFE;EACE,6BAAA;EACA,uBAAA;AAIJ","sourcesContent":[".label_content{\r\n  float: left;\r\n  position: relative;\r\n  top: 18%;\r\n}\r\n\r\n.controls_feild{\r\n  width: 70%;\r\n    float: left;\r\n    margin-left: 4%;\r\n    height: 35px;\r\n}\r\n\r\n.controls_feild_lookvalue{\r\n  width: 65%;\r\n    float: left;\r\n    margin-left: 4%;\r\n    height: 35px;\r\n    margin-top: -2px!important;\r\n}\r\n\r\n.icons{\r\n  font-size: 16px;\r\n  width: 16px;\r\n  height: 16px;\r\n  position: relative;\r\n  top: 0px;\r\n}\r\n.interfaceMappingUpload {\r\n  // font-size: 100px;\r\n  width: 3% !important;\r\n  left: unset;\r\n  opacity: 0 !important;\r\n  position: absolute !important;\r\n  top: 1% !important;\r\n  overflow: hidden !important;\r\n  right: 12% !important;\r\n}\r\n\r\n::ng-deep.messageFormat_select{\r\n  padding-left: 10px !important;\r\n}\r\n::ng-deep.messageFormat_select .mat-form-field-infix{\r\n  border: 0 !important;\r\n  height: 33px !important;\r\n  font-size: 13px;\r\n}\r\n::ng-deep.messageFormat_select .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n::ng-deep.messageFormat_select .mat-form-field-label-wrapper{\r\n  top:-1px !important;\r\n}\r\n::ng-deep.messageFormat_select  .mat-select-trigger {\r\n  min-width: 10vw;\r\n}\r\n\r\n.searchtext{\r\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;\r\n  border-radius: 5px !important;\r\n}\r\n\r\n::ng-deep.messageFormat_select {\r\n  .mat-mdc-text-field-wrapper{\r\n    height: 35px !important;\r\n  }\r\n  .mat-mdc-form-field-subscript-wrapper{\r\n    display: none !important;\r\n  }\r\n  .mat-mdc-select{\r\n    position: relative !important;\r\n    bottom: 11px !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
